import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';

import { User } from '../types';
import { buildUrl } from '../buildUrl';
import { filterNonAdministratorUsers } from '../user.helpers';

import { userQueryKeys } from './queryKeys';

export function useUsers<T = User[]>(
  includeAdministrator = false,
  environmentId = 0,
  enabled = true,
  select: (data: User[]) => T = (data) => data as unknown as T
) {
  const users = useQuery(
    userQueryKeys.list({
      includeAdministrator,
      environmentId,
    }),
    () => getUsers(includeAdministrator, environmentId),
    {
      meta: {
        error: { title: 'Failure', message: 'Unable to load users' },
      },
      enabled,
      select,
    }
  );

  return users;
}

export async function getUsers(
  includeAdministrators = false,
  environmentId = 0
) {
  try {
    const { data } = await axios.get<User[]>(buildUrl(), {
      params: { environmentId },
    });

    return includeAdministrators ? data : filterNonAdministratorUsers(data);
  } catch (e) {
    throw parseAxiosError(e as Error, 'Unable to retrieve users');
  }
}
